import { AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { TestFailureModalContext, TestFailureModalService } from 'src/app/services/test-failure-modal.service';

@Component({
  selector: 'test-failure-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './test-failure-modal.component.html',
  styleUrl: './test-failure-modal.component.scss'
})
export class TestFailureModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('content') private content!: TemplateRef<unknown>;

  ctx: TestFailureModalContext | null = null;

  private modalRef?: NgbModalRef;
  private readonly subscription = new Subscription();

  constructor(
    private testFailureModalService: TestFailureModalService,
    private modalService: NgbModal
  ) { }

  ngAfterViewInit(): void {
    this.subscription.add(
      this.testFailureModalService.state$.subscribe(state => {
        if (state.isOpen && state.context) {
          this.ctx = state.context;
          this.openModal();
        } else {
          this.closeModal();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.closeModal();
  }

  private openModal(): void {
    if (this.modalRef) {
      return;
    }

    this.modalRef = this.modalService.open(this.content, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      windowClass: 'test-failure-modal'
    });

    // Chiusura con ESC: equivale al pulsante "Back".
    this.modalRef.result.catch(() => {
      this.modalRef = undefined;
      const onClose = this.ctx?.onClose;
      this.ctx = null;
      onClose?.(true);
      this.testFailureModalService.close();
    });
  }

  private closeModal(): void {
    this.ctx = null;
    const ref = this.modalRef;
    this.modalRef = undefined;
    ref?.dismiss();
  }
}
